import gql from 'graphql-tag'

export default gql`
	query getAppConfigAdditional {
		cashAssist {
			getAppConfigAdditional {
				discountGroupNames
				defaultDiscountMobileCard
				bexioApiToken
				brotZeitApiToken
				pentacodeEnabled
				isMirusExportEnabled
			}
		}
	}
`
